import {TrackClickEvent} from "./models";

export const TRACKING_SERVICE_KEY = 'NY_TRACKER';

declare global {
  interface Window {
    NY_TRACKER: ITrackingService
    dataLayer: any[]
  }
}

export interface ITrackingService {
  trackClick(event: TrackClickEvent): void;
  trackPage(path: string, title: string): void;
}

export function getTrackingService(): ITrackingService {
  const ts = window[TRACKING_SERVICE_KEY];
  if (ts) {
    return ts as ITrackingService;
  }
  return null
}

